module.exports = __webpack_public_path__ + "static/MW3_POST_PARTNER-eca1750341a021efdb70c162a899420b.png";